import { all, fork } from "redux-saga/effects";

import notificationSaga from "@iso/redux/notifications/saga";
import chatSaga from "@iso/redux/chat/saga";

export default function* rootSaga(getState) {
  yield all([fork(notificationSaga), fork(chatSaga)]);
}
